<nb-card style="width:100%">

  <nb-card-body [formGroup]="DayForm" style="width:100%">

    <div class="row FramePadding">
      <div>
        <div *ngIf="!PlanView" [hidden]="HidePlanName">
          <div>
            <ul>
              <li>
                Day
                <div i18n="@@DayName" class="label col-form-label">Day Name</div>
              </li>
              <li style="width:1100px">
                <input formControlName="DayName" nbInput type="text" fullWidth shape="semi-round"
                  i18n-placeholder="@@DayName" placeholder="Day Name" (change)="NameChange($event)"
                  [attr.disabled]="PlanView ? true : null">
                <ngx-validation-message i18n-label="@@DayName" label="Day Name"
                  [showMinLength]="DayName?.hasError('minlength')" [showMaxLength]="DayName?.hasError('maxlength')"
                  [showRequired]="DayName?.errors?.required && DayName.touched" minLength=5 maxLength=50>
                </ngx-validation-message>
              </li>
            </ul>
          </div>
        </div>

        <!-- Assign to week days -->
        <ul class="basic_list_informations row">
          <li i18n="@@AssignToWeekDays" class="GeneralLabel2 plan-day-assign-week-days col-12">
            Assigned week days
          </li>
          <li class="col-12 pt-1">
            <day-of-week-checker formControlName="assignWeekDays" [readonly]="PlanView"
              [attr.disabled]="PlanView ? true : null" (change)="onAssignWeekDaysChagne($event)">
            </day-of-week-checker>
          </li>
        </ul>

        <!-- Notes -->
        <ul class="basic_list_informations row">
          <li i18n="@@Notes" class="GeneralLabel2 plan-day-notes col-sm-2">
            Notes
          </li>
          <li class="plan-day-notes-editor col-sm-10">
            <smart-edit formControlName="DayNotes" i18n-placeholder="@@Notes" placeholder="Notes" [readonly]="PlanView"
              [IsMultiLine]="true" [MaxLength]="FormConstants.NotesMaxLength" [(MultiLineHeight)]="DayNotesHeight"
              [attr.disabled]="PlanView ? true : null" (keyup)="NotesChange($event)">
            </smart-edit>

            <ngx-validation-message i18n-label="@@Notes" label="Notes" [showMaxLength]="DayNotes?.hasError('maxlength')"
              [maxLength]="FormConstants.NotesMaxLength">
            </ngx-validation-message>
          </li>
        </ul>
      </div>
    </div>
    <div class="row">

      <div class="col">
        <div class="total-metrics-container float-right">
          <adjust-app-meal-metrics-graph #DayMetricsGraphView class="Metrics {{PlanView ? 'plan-view' :''}}"
            [ViewOnly]="PlanView" [MealCals]="MealCals" [MealProtein]="MealProtein" [MealCarbs]="MealCarbs"
            [MealNetCarbs]="MealNetCarbs" [MealFats]="MealFats" [PlanDays]="PlanDays" [ActiveDay]="Day">
          </adjust-app-meal-metrics-graph>
        </div>
      </div>

    </div>


    <div class="row">
      <div class="col-sm-12">
        <div *ngFor="let meal of Day.meals; let i = index">
          <div class="remove-meal-wrapper">
            <div class="remove-meal-action">
              <button
              nbButton
              class="btn-remove-meal"
              alt="Copy"
              (click)="Copy(meal)"
              style="padding: 0px !important"
            >
              <nb-icon icon="copy-outline" alt="Copy"></nb-icon>
            </button>

            <button
              nbButton
              alt="Paste"
              class="btn-remove-meal"
              (click)="Paste(meal, i)"
              [hidden]="!HasClipboard()"
              style="padding: 0px !important"
            >
              <nb-icon icon="clipboard-outline" alt="Paste"></nb-icon>
            </button>

              <button nbButton class="btn-remove-meal" (click)="RemoveMeal(meal)"
                [hidden]="PlanView || !CanRemoveMeal">
                <nb-icon icon="trash-2-outline"></nb-icon>
              </button>
            </div>
          </div>
          <app-meal-presentation #MealPresentation [Patient]="Patient" [PlanMeal]="meal" [Index]="i" [PlanView]="PlanView">
          </app-meal-presentation>
          <div style="height:10px"></div>
        </div>
      </div>
    </div>

  </nb-card-body>

  <nb-card-footer [hidden]="PlanView || NewDayView">
    <div>
      <button i18n="@@Accept" nbButton type="submit"  (click)="Accept()" class="btn-circle btn-xl btn-main btn-circle btn-xl"
        [disabled]="!DayForm.valid" [hidden]="!ShowSubmit">Accept</button>
      <!--<button nbButton class="btn-circle btn-xl btn-main btn-main" status="info" (click)="Back()">{{BackLabel}}</button>-->
      <button i18n="@@AddNewMeal" nbButton type="submit"  (click)="NewMeal()"
        class="btn-circle btn-xl btn-main btn-circle btn-xl">Add New Meal</button>
    </div>
  </nb-card-footer>

  <nb-card-footer [hidden]="!NewDayView || PlanView">
    <div>
      <button i18n="@@Accept" nbButton type="submit"  (click)="Accept()" class="btn-circle btn-xl btn-main btn-circle btn-xl"
        [disabled]="!DayForm.valid" [hidden]="!ShowSubmit">Accept</button>
      <!--<button nbButton class="btn-circle btn-xl btn-main btn-main" status="info" (click)="Back()">{{BackLabel}}</button>-->
      <button i18n="@@AddNewMeal" nbButton type="submit"  (click)="NewMeal()"
        class="btn-circle btn-xl btn-main btn-circle btn-xl">Add New Meal</button>
    </div>
  </nb-card-footer>
  <span style="font-size: 8pt; color: gray; margin-left: 15px;" [hidden]="!this.isNativeApp">* Tap on Food Item to view
    source information.</span>
</nb-card>
